export default __webpack_public_path__ + "static/joko-app-screenshot-home-2-fr-e993a66af2b764eeb60f67ebd7d6c846.png";